import { writable } from "svelte/store";
const storedAttendantName = localStorage.getItem("userName") || "";
export const attendantName = writable(storedAttendantName);
attendantName.subscribe((value) => {
    if (value) {
        localStorage.setItem("userName", value);
    }
    else {
        localStorage.removeItem("userName");
    }
});
export const isAuthenticated = writable(false);
